import axios from "axios";
import { APIURL } from "./config";
import { CONTACT_MESSAGE_LIST } from "./type";
import { toast } from "react-toastify";

export const contactList = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/contact`, config);
    dispatch({
      type: CONTACT_MESSAGE_LIST,
      payload: res.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
